import StandardGroupBlock from "../standard-group-block";
import CardGroupBlock from "../card-group-block";
import ExternalCallOuts from "./external-callouts";
import MasonryBlocks from "./masonry-blocks";
import WhyStudyBlock from "../../academics/why-study-block";
import InfographicBlockGroup from "../infographic-block-group";
import RealWorldExperienceBlock from "../../academics/real-world-experience-block";
import FAQBlock from "./faq-block";


const PageBlockGroup = ({ props, section }) => {
  const pageBlockGroup = props;
  const map = new Map();
  map.set("standard", StandardGroupBlock);
  map.set("standardGroupWithMedia", StandardGroupBlock);
  map.set("standardGroupWithoutMedia", StandardGroupBlock);
  map.set("horizontalCardsWithoutPhotos", CardGroupBlock);
  map.set("verticalCardsWithPhotos", CardGroupBlock);
  map.set("horizontalCardsWithPhotos", CardGroupBlock);
  map.set("cards", CardGroupBlock);
  map.set("FAQs", FAQBlock);
  map.set("imageCluster", RealWorldExperienceBlock);
  map.set("infographicBlocks", InfographicBlockGroup);
  map.set("numberedList", WhyStudyBlock);
  map.set("externalCallOuts", ExternalCallOuts);
  map.set("masonryBlocks", MasonryBlocks);
  let Component = map.get(pageBlockGroup.pageBlockType);
  return Component === undefined ? (
    <p>Need to select a Group Block Type for {pageBlockGroup.pageBlockType}</p>
  ) : (
    <Component pageBlockGroup={pageBlockGroup} section={section} />
  );
};

export default PageBlockGroup;
